export default __webpack_public_path__ + "static/media/copy.5fd9f632.svg";